import axios, { type AxiosError, type InternalAxiosRequestConfig } from 'axios'
import { fetchAuthSession } from 'aws-amplify/auth'
import { apiConfig, hakuouApiConfig } from '@/config/aws'
import type { AccessRules } from '@/types/rules'

const api = axios.create({
  baseURL: apiConfig.baseUrl,
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json',
  },
})

api.interceptors.request.use(
  async (config: InternalAxiosRequestConfig) => {
    try {
      const session = await fetchAuthSession()
      const token = session.tokens?.idToken?.toString()

      if (token && config.headers) {
        config.headers.Authorization = `Bearer ${token}`
      }
    } catch (error) {
      console.error('Failed to get auth token:', error)
    }

    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

api.interceptors.response.use(
  (response) => response,
  (error: AxiosError) => {
    // 401 はトークン audience 不一致や期限切れで発生する。
    // location.href = '/' でリロードしてしまうと未認証時に同じページを延々と読み直す無限ループになるので、
    // ハンドリングは呼び出し側 (React Query) に委ねる。
    return Promise.reject(error)
  }
)

export async function fetchRules(): Promise<AccessRules> {
  const response = await api.get<AccessRules>('/rules')
  return response.data
}

export async function updateRules(rules: AccessRules): Promise<void> {
  await api.put('/rules', rules)
}

const hakuouApi = axios.create({
  baseURL: hakuouApiConfig.baseUrl,
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json',
  },
})

hakuouApi.interceptors.request.use(
  async (config: InternalAxiosRequestConfig) => {
    try {
      const session = await fetchAuthSession()
      const token = session.tokens?.idToken?.toString()

      if (token && config.headers) {
        config.headers.Authorization = `Bearer ${token}`
      }
    } catch (error) {
      console.error('Failed to get auth token:', error)
    }

    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

export async function fetchSites(): Promise<string[]> {
  const response = await hakuouApi.get('/api/sites')
  console.log('fetchSites response:', response.data)
  const sites = response.data?.sites
  if (!Array.isArray(sites)) return []
  return sites.map((s: { id: string }) => s.id)
}

export default api
